import { useState } from 'react'

interface WorkdayJobsFilterPropsObjectString {
  path?: string
  jobFunction?: string
  businessUnit?: string
  productGroup?: string
  locations?: string
  applyNowUrl?: string
  title?: string
  jobType?: string
  experience?: string
  typeOfContract?: string
}
export type WorkdayJobsFilterProps = {
  filters: WorkdayJobsFilterPropsObjectString
  tempSelections: WorkdayJobsFilterPropsObjectString
  headerLabels: WorkdayJobsFilterPropsObjectString
  filterFields: string[]
  openDropdown?: string
  getOptions: (field: string) => void
  toggleDropdown: (field: string) => void
  resetField: (field: string) => void
  applyFilter: (field: string) => void
  applyFooterFilter: (field: string) => void
  toggleOption: (field: string, value: string) => void
  hidelocation?: string
  hidejobtype?: string
  hidetypeofcontract?: string
  hideexperience?: string
  hidejobfunction?: string
  hidebusinessunit?: string
  hideproductgroup?: string
  filteredJobscount?: number
}
export default function WorkdayJobs({
  openDropdown,
  toggleDropdown,
  toggleOption,
  getOptions,
  headerLabels,
  filterFields,
  resetField,
  applyFilter,
  applyFooterFilter,
  filteredJobscount,
  filters,
  tempSelections,
  hidelocation,
  hidejobtype,
  hidetypeofcontract,
  hideexperience,
  hidejobfunction,
  hidebusinessunit,
  hideproductgroup,
}: WorkdayJobsFilterProps) {
  const [isFilterbarOpened, setIsFilterbarOpened] = useState(false)

  const openFilterbarHandler = () => setIsFilterbarOpened(!isFilterbarOpened)
  const closeFiltersHandler = () => {
    setIsFilterbarOpened(false)
  }

  const HiddenfilterFields = {
    locations: hidelocation,
    jobType: hidejobtype,
    typeOfContract: hidetypeofcontract,
    experience: hideexperience,
    jobFunction: hidejobfunction,
    businessUnit: hidebusinessunit,
    productGroup: hideproductgroup,
  }

  return (
    <div data-dm="filterbar.component" className="cmp-filterbar__container">
      <div className="cmp-filterbar">
        <button data-dm="filterbar.button" onClick={openFilterbarHandler} className="cmp-filterbar__button--is-open-filterbar">
          {'Filter'}
        </button>
        <div className={`cmp-filterbar__wrapper ${isFilterbarOpened ? 'cmp-filterbar__wrapper--is-open' : ''} `}>
          <div className="cmp-filterbar__header">
            <button
              onClick={() => toggleDropdown(openDropdown)}
              className={`cmp-filterbar__header--is-back ${isFilterbarOpened && !openDropdown ? 'cmp-filterbar__header--is-hidden' : ''} `}
            >
              <span className="icon-keyboard_arrow_left icon--md"></span>Back
            </button>
            <span className="cmp-filterbar__header-title">Filter by</span>
            <button
              className={`cmp-filterbar__header--is-close ${isFilterbarOpened && openDropdown ? 'cmp-filterbar__header--is-hidden' : ''}`}
              onClick={closeFiltersHandler}
              aria-labelledby="Close"
            >
              <span className="icon-close icon--md"></span>
            </button>
          </div>
          <div className="cmp-filterbar__body">
            <div className={`cmp-filterbar__filters ${openDropdown ? 'cmp-filterbar__filters--is-open' : ''}`}>
              {filterFields.map(field => {
                const label = headerLabels[field]
                const options = getOptions(field)
                const tempSelected = tempSelections[field] || []

                if (HiddenfilterFields[field]) {
                  return false
                }

                return (
                  <div key={field} className="cmp-filterbar__filter cmp-filterbar__filter-dropdown">
                    <label className="cmp-filterbar__dropdown-label" htmlFor={`${field}-group-label`}>
                      {label}
                    </label>

                    <div
                      className={`cmp-filterbar__dropdown ${openDropdown === field ? 'cmp-filterbar__dropdown--is-open' : ''} ${options.length === 0 ? 'cmp-filterbar__dropdown--is-disabled' : ''}`}
                    >
                      <button
                        id={`${field}-group-label`}
                        className="cmp-filterbar__dropdown-button"
                        aria-label={`Filter toggle for: ${label}`}
                        onClick={() => toggleDropdown(field)}
                      >
                        <span className="cmp-filterbar__dropdown-button--desktop-label"></span>
                        <span className="cmp-filterbar__dropdown-button--mobile-label">{label}</span>
                        {filters[field]?.length && filters[field]?.length !== 0 ? (
                          <span className="cmp-filterbar__dropdown-button--selected-checkboxes">{filters[field].length}</span>
                        ) : (
                          ''
                        )}
                      </button>

                      {openDropdown === field && (
                        <div role="group" aria-labelledby={`${field}-group-label`} className="cmp-filterbar__dropdown-container">
                          <ul className="cmp-filterbar__dropdown-checkboxes">
                            {options.map(option => (
                              <li className="cmp-filterbar__checkbox-item" key={option}>
                                <div className="cmp-filterbar__checkbox-item-wrapper">
                                  <div
                                    className={`cmp-filterbar__checkbox-input ${tempSelected.includes(option) ? 'cmp-filterbar__checkbox-input--is-checked' : ''}`}
                                    role="checkbox"
                                    aria-checked={tempSelected.includes(option)}
                                    aria-label={option}
                                    tabIndex={0}
                                    onClick={() => toggleOption(field, option)}
                                  >
                                    <span dangerouslySetInnerHTML={{ __html: option }}></span>
                                  </div>
                                </div>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                      <div className="cmp-filterbar__dropdown-footer">
                        <button
                          className="cmp-filterbar__button cmp-filterbar__button--reset"
                          aria-label={`RESET: ${label}`}
                          onClick={() => resetField(field)}
                        >
                          <span className="icon--sm icon-reset icon-placement--before-label"></span>
                          <span className="cmp-filterbar__button-text">Reset</span>
                        </button>
                        <button
                          className="cmp-filterbar__button cmp-filterbar__button--select"
                          aria-label={`SELECT: ${label}`}
                          onClick={() => applyFilter(field)}
                        >
                          <span className="cmp-filterbar__button-text">Select</span>
                        </button>
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
            <div className="cmp-filterbar__active-filters">
              <p className="cmp-filterbar__count">{`${filteredJobscount} items`}</p>
            </div>
          </div>
        </div>
        <div className="cmp-filterbar__footer">
          <button
            className="cmp-filterbar__button cmp-filterbar__button--select"
            onClick={openDropdown ? () => applyFooterFilter(openDropdown) : closeFiltersHandler}
          >
            <span className="cmp-filterbar__button-text">{openDropdown ? 'Select' : `View ${filteredJobscount} Items`}</span>
          </button>
        </div>
      </div>
    </div>
  )
}
